import { FORM_ID, FORMAT_YEAR_MONTH_DAY_HYPHEN, MILEAGE_TEST_ID } from '../../../../constants'
import AuthCustomLabel from '../../../../pages/qb/Auth/Content/AuthCustomLabel'
import { FormConfigType } from '../../../../types/interface/form.interface'
import {
  RFFCustomDatePicker,
  RFFCustomSelect,
  RFFCustomSwitch,
  RFFCustomTextField,
} from '@dg-shared'
import PhoneFieldLabel from '../../../../pages/qb/Verify/Content/PhoneFieldLabel'
import CoverageCustomLabel from '../../../../pages/qb/Change/Content/CoverageCustomLabel'
import SuperCoverCustomLabel from '../../../../pages/qb/Change/Content/SuperCoverCustomLabel'
import { CoverageTypeKeyType } from '../../../../types/interface/quote.interface'

const FormConfig: FormConfigType = {
  [FORM_ID.AUTH]: {
    vehicle: {
      id: FORM_ID.AUTH,
      fields: {
        ssn: {
          name: 'ssn',
          type: 'tel',
          component: RFFCustomTextField,
          customLabel: AuthCustomLabel,
        },
        regNum: {
          name: 'regNum',
          component: RFFCustomTextField,
        },
      },
      initialValues: {},
    },
  },
  [FORM_ID.COMPARE_AUTH]: {
    vehicle: {
      id: FORM_ID.COMPARE_AUTH,
      fields: {
        ssn: {
          name: 'ssn',
          type: 'tel',
          component: RFFCustomTextField,
          labelPlacement: 'top',
        },
      },
      initialValues: {},
    },
  },
  [FORM_ID.CHANGE]: {
    vehicle: {
      id: FORM_ID.CHANGE,
      fields: {
        coverageType: {
          name: 'coverageType',
          component: RFFCustomSelect,
          customLabel: CoverageCustomLabel,
          componentProps: {
            fetchOptions: true,
          },
        },
        superCover: {
          name: 'superCover',
          type: 'checkbox',
          component: RFFCustomSwitch,
          labelPlacement: 'top',
          customLabel: SuperCoverCustomLabel,
          dependency: [
            {
              fieldName: 'coverageType',
              value: [CoverageTypeKeyType.halv, CoverageTypeKeyType.hel],
            },
          ],
          initialValue: false,
        },
        deductible: {
          name: 'deductible',
          component: RFFCustomSelect,
          dependency: [
            {
              fieldName: 'coverageType',
              value: CoverageTypeKeyType.hel,
            },
          ],
          initialValue: '4500',
          componentProps: {
            fetchOptions: true,
          },
        },
        mileageAnnual: {
          name: 'mileageAnnual',
          component: RFFCustomSelect,
          testId: MILEAGE_TEST_ID,
          componentProps: {
            fetchOptions: true,
          },
        },
        ageLimit: {
          name: 'ageLimit',
          type: 'checkbox',
          component: RFFCustomSwitch,
          labelPlacement: 'top',
        },
      },
      initialValues: {
        coverageType: CoverageTypeKeyType.halv,
      },
    },
  },
  [FORM_ID.VERIFY]: {
    vehicle: {
      id: FORM_ID.VERIFY,
      fields: {
        policyDate: {
          name: 'policyDate',
          type: 'tel',
          component: RFFCustomDatePicker,
          componentProps: {
            fieldInputVariant: 'outlined',
            fieldMinDate: Date.now(),
            // +1 year from now
            fieldMaxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).getTime(),
            formatType: FORMAT_YEAR_MONTH_DAY_HYPHEN,
            iconColor: 'secondary',
          },
        },
        email: {
          name: 'email',
          type: 'email',
          component: RFFCustomTextField,
        },
        phone: {
          name: 'phone',
          type: 'tel',
          component: RFFCustomTextField,
          customLabel: PhoneFieldLabel,
        },
      },
      initialValues: {},
    },
  },
}

export default FormConfig
